import * as React from 'react';

//import fondo from '../../images/oficina.jpg'
import fondo from '../../images/statistics-2899919.jpg'


export default class HomePage extends React.Component {

    render() {
        return <div>
            <img src={fondo} className="App-wallpaper" alt="logo" />
        </div>
    }
}